import React from 'react'
import cn from 'classnames'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { toggleMenu} from "./SideMenu/Menu/toggler";
import { statuses } from 'store/auth/consts'

import Preloader from 'components/common/elements/Preloader'
import { userStatuses } from 'store/auth'
import history from 'services/browserHistory'
import { inviteCodePath } from "components/routes/authGroup/InviteCode";

import SideMenu from './SideMenu/SideMenu'

import { gsBody, gsBodyContent, menuOpen } from './MainLayout.scss'

const Layout = ({ userStatus, accStatus, setMenuOpen, isMenuOpen, component: Component, ...rest }) => {
  if (userStatus == userStatuses.LOADING) return <Preloader/>;
  if (userStatus == userStatuses.UNAUTH) {
    history.push('/login');
    return <Preloader/>;
  }
  if (accStatus == statuses.PENDING) {
    history.push(inviteCodePath)
    // console.log('need push to gateleeper')
  }

  return (
    <Route {...rest} render={ matchProps => (
      <div className={cn(gsBody, { [menuOpen]: isMenuOpen})}>
        <SideMenu isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen}/>
        <div className={gsBodyContent}>
          <Component {...matchProps} />
        </div>
      </div>
    )}/>
  );
}

const mapStateToProps = (state) => ({
  userStatus: state.auth.status,
  accStatus: (state.entities.users[state.auth.id] || {}).status,
  // userId: state.auth.id,
  isMenuOpen: state.global.navigationOpened,
})

const mapDispatchToProps = {
  setMenuOpen : (menuOpened) => toggleMenu(menuOpened),
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
